module.exports = __webpack_public_path__ + "static/img/orange.945d0b73.jpg";